module.exports = __webpack_public_path__ + "img/banner空白图.dd67e5f0.png";